import { getRegisterFunction } from '../../utils/register.js';
import { OneUxTextareaElement } from './OneUxTextareaElement.js';
export const register = getRegisterFunction(OneUxTextareaElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-textarea': OneUxTextareaElement;
    "textarea-68bf87d442791a263533a2bdf39f30a3": OneUxTextareaElement;
  }
}